import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({ endPoint: 'FinancingTypeProduct/GetFinancingFieldsProduct', method: 'GET', body: null, token: token })
}
